import Section from '../../utils/section/Section';

export default function GtmLastMinuteSection(): JSX.Element {
  return (
    <div className="gtm-last-minute-section">
      <Section>
        <div className="gtm-last-minute-section-container" />
      </Section>
    </div>
  );
}
